import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fluid":""}},[_c(VRow,{attrs:{"justify":"center"}},[_vm._l((_vm.categories),function(category){return [(_vm.showCategoryBox(category))?_c(VCol,{key:category.uuid,ref:category.uuid,refInFor:true,staticClass:"pt-2 pb-2 pl-4 pr-4",staticStyle:{"width":"100%"},attrs:{"id":category.uuid,"cols":_vm.colsSize(category)}},[_c('category-box',{attrs:{"id":_vm.categoryName(category),"category":category}})],1):_vm._e()]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }